import { render, staticRenderFns } from "./Lottery2020.vue?vue&type=template&id=34b24f12&scoped=true&"
import script from "./Lottery2020.vue?vue&type=script&lang=js&"
export * from "./Lottery2020.vue?vue&type=script&lang=js&"
import style0 from "./Lottery2020.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Lottery2020.vue?vue&type=style&index=1&id=34b24f12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b24f12",
  null
  
)

export default component.exports